import React from 'react';
import { Select, Option } from '@material-tailwind/react';

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectInputProps {
  label: string;
  options: SelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

const SelectInput: React.FC<SelectInputProps> = ({
  label,
  options,
  value,
  onChange,
  disabled = false,
  className = 'min-w-14',
}) => {
  return (
    <div className={className}>
      <Select
        label={label}
        value={value}
        onChange={val => onChange?.(val || '')}
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        disabled={disabled}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        className={`
                  peer
                  bg-[var(--inputBackground)]
                  text-[var(--inputText)]
                  placeholder-[var(--inputPlaceholder)]
                  border
                  border-[var(--inputBorder)]
                  !border-t-[var(--inputBorder)] 
                  !border-t 
                  focus:border-[var(--inputFocusBorder)]
                  focus:ring-2 
                  focus:ring-[var(--inputFocusBorder)]
                  disabled:bg-[var(--inputDisabledBackground)]
                  disabled:text-[var(--inputDisabledText)]
                  disabled:cursor-not-allowed
                  disabled:opacity-70
                  before:content-none
                  after:content-none
`}
        labelProps={{
          className:
            '!text-[var(--textMuted)] peer-focus:!text-[--var(--text)] focus:!text-[--var(--text)]',
        }}
        menuProps={{
          className: 'bg-[var(--card)] text-[var(--text)]',
        }}
      >
        {options.map(opt => (
          <Option key={opt.value} value={opt.value}>
            {opt.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectInput;
